export default [
  {
    value: 'round',
    label: 'Round'
  },
  {
    value: 'cushion',
    label: 'Cushion'
  },
  {
    value: 'princess',
    label: 'Princess'
  },
  {
    value: 'oval',
    label: 'Oval'
  },
  {
    value: 'emerald',
    label: 'Emerald'
  },
  {
    value: 'asscher',
    label: 'Asscher'
  },
  {
    value: 'pear',
    label: 'Pear'
  },
  {
    value: 'radiant',
    label: 'Radiant'
  },
  {
    value: 'marquise',
    label: 'Marquise'
  },
  {
    value: 'heart',
    label: 'Heart'
  },
  {
    value: 'trilliant',
    label: 'Trilliant'
  }
]



// WEBPACK FOOTER //
// ./src/components/select-shapes/shapes.js